<template>
  <div class="login">
    <div class="header">
      <div class="logo">
        <img src="../../static/logoMobile.png" alt="" />
        <p>{{ $t('logo.title') }}</p>
      </div>
      <!-- <div class="logo2">
        <img src="../../static/title_logo.png" />
      </div> -->
    </div>
    <div class="loginfrom">
      <div class="exit">
        <p @click="goHome()" style="cursor: pointer;"><i class="el-icon-arrow-left"></i>{{ $t('logo.quit') }}</p>
        <p v-if="toggle" @click="changeCn">CH</p>
        <p v-else @click="changeCn">EN</p>
      </div>
      <div class="title">
        <h3>{{ $t('logo.denglu') }}</h3>
        <p>{{ $t('logo.biaoti') }}</p>
        <el-form ref="sizeForm" class="form" :rules="rules" :model="sizeForm" label-width="" size="mini">
          <el-form-item label="" prop="username">
            <el-input :placeholder="$t('logo.placeholder')" prefix-icon="el-icon-user" v-model="sizeForm.username"> </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <!-- <el-input
              placeholder="请输入内容"
              prefix-icon="el-icon-lock"
              v-model="sizeForm.password"
            
              :type="passwordVisible"
              id="password"


            >
              <i slot="suffix" title="显示密码"  :class="icon" @click="showPass" style="margin-right:10px;margin-top:13px"></i>
            </el-input> -->
            <el-input :placeholder="$t('logo.placeholder1')" prefix-icon="el-icon-lock" v-model="sizeForm.password" show-password id="password"> </el-input>
          </el-form-item>
          <el-checkbox v-model="checked">{{ $t('logo.tiaokuan1') }}</el-checkbox>
          <span @click="agreement1">{{ $t('logo.tiaokuan2') }}</span>

          <el-button type="primary" class="button" @click="submitForm('sizeForm')">{{ $t('logo.submit') }}</el-button>
        </el-form>
        <p>
          {{ $t('logo.noAccount') }} <span @click="apply()">{{ $t('logo.canzhan') }}</span>
        </p>
        <p><i>*</i> {{ $t('logo.tiaokuan3') }}<span>010-64253061</span></p>
        <p>更多展商后台功能，请登录展商后台PC端</p>
      </div>
    </div>

    <!--脚log -->
    <div class="footer">
      <img src="../../static/易展logo.png" alt="" />
    </div>
    <div class="alert" v-if="agreement">
      <i class="el-icon-close" @click="close"></i>
      <h3>{{ $t('logo.mianze.mianzeTitle') }}</h3>
      <div class="wenzhang1 mianzeContent">{{ $t('logo.mianze.mianzeContent') }}</div>
      <div class="wenzhang1">
        <h5>{{ $t('logo.mianze.account') }}</h5>
        <p>
          {{ $t('logo.mianze.mianze1') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze2') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze3') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze4') }}
        </p>
      </div>
      <div class="wenzhang1">
        <h5>{{ $t('logo.mianze.mianze6') }}</h5>
        <p>
          {{ $t('logo.mianze.mianze7') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze8') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze9') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze10') }}
        </p>
        <p>
          {{ $t('logo.mianze.mianze11') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../../../api/login.js';
import { backFront, viewApply } from '../../../utils/common.js';
import { VRLogin } from '../../../utils/way.js';
import config from '../../../config.js';
export default {
  data() {
    return {
      backFront: backFront(),
      viewApply: viewApply(),
      icon: 'el-icon-view',
      // passwordVisible:'password', // 更换密码类型标识
      sizeForm: {
        username: '',
        password: '',
      },
      checked: false,
      agreement: false,
      flage: 1,
      toggle: false,
    };
  },
  created() {
    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    this.lang = language ? language : 'zh';
    this.toggle = language == 'en' ? true : false;
  },
  computed: {
    rules() {
      return {
        username: [{ required: true, message: this.$t('logo.dialglog.rules1'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('logo.dialglog.rules2'), trigger: 'blur' }],
      };
    },
  },
  methods: {
    // showPass(){
    //    if( this.passwordVisible==="text"){
    //        this.passwordVisible="password";
    //        //更换图标
    //        this.icon="el-icon-view";
    //      }else {
    //        this.passwordVisible="text";
    //        this.icon="el-icon-lock";
    //      }

    // },
    apply() {
      window.location.href = this.viewApply;
    },
    // entryVr(id) {
    //   const exId = id; //展商Id
    //   const that = this;
    //   const VrLoginData = { ...VRLogin(exId, that) };
    //   var scriptNode = document.createElement('script');
    //   scriptNode.type = 'text/javascript';
    //   scriptNode.src = `${config.vrUrl}/apiaccount/signin?hzExhibitor_id=${VrLoginData.hzExhibitor_id}&sign=${VrLoginData.sign}&time=${VrLoginData.time}`;
    //   document.getElementsByTagName('head')[0].appendChild(scriptNode);
    // },

    changeCn() {
      if (this.toggle == true) {
        // 当前显示的是中文图标,说明页面内容是英文,
        // todo: 把图标变为英文图标，内容变为中文
        this.toggle = false;
        localStorage.setItem('lang', 'zh');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
        // 存到localStorage的语言是zh
      } else if (this.toggle == false) {
        // 当前显示的是英文图标,说明页面内容是中文,
        // todo: 把图标变为中文图标，内容变为英文
        this.toggle = true;
        localStorage.setItem('lang', 'en');
        this.$i18n.locale = 'en';
        this.lang = 'en';
        // 存到localStorage的语言是en
      }
      window.location.reload();
    },
    goHome() {
      window.location.href = this.backFront;
    },
    async login(Logmsg) {
      let formdata = {
        username: "",
        password: "",
      };
      let Base64 = require('js-base64').Base64
      // console.log(Base64);
      formdata.username = Base64.encode(Logmsg.username);
      formdata.password =Base64.encode(Logmsg.password);
      try {
        const { data } = await login(formdata);
        if (!this.checked) {
          this.$message.error(this.$t('logo.dialglog.diaglogMess'));
        } else if (this.checked && data.code == 200) {
          //----------------展商登录成功后进行登录验证-------------------
          const id = data.data.userInfo.id;
          localStorage.setItem('exid', id); //存储展商Id
          // this.entryVr(id);登录时候不再同步登录VR
          this.$router.push('/backIndex/homeIndex');
          localStorage.setItem('token', data.data.token);
          this.$message({ message: this.$t('logo.dialglog.logSuccess'), type: 'success' });
        } else {
          this.$message.error(this.$t('logo.dialglog.logceil'));
        }
      } catch (error) {
        console.log(error);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login(this.sizeForm); //执行提交操作
        } else {
          this.$message.error(this.$t('logo.dialglog.notNull'));
          return false;
        }
      });
    },
    agreement1() {
      this.agreement = true;
    },
    close() {
      this.agreement = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 198vw;
  position: relative;
  background: url('../../static/weitu.png') no-repeat;

  // border:1px solid red;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 25px 12px;

    .logo {
      width: 100vw;
      height: 20.53vw;

      p {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 25px;
        margin-left: 14.3vw;
        margin-top: 8px;
      }
      img {
        width: 100%;
      }
    }
    .logo2 {
      img {
        width: 161px;
        height: 40px;
      }
    }
  }

  .loginfrom {
    width: 92vw;
    background: rgba(255, 255, 255, 0.88);
    background-size: 100%;
    box-shadow: 0px 5px 7px 0px rgba(139, 139, 139, 0.5);
    border-radius: 12px;
    border: 1px solid;
    margin: 0 auto;
    padding: 5.3vw 4vw;
    margin-top: 7.7vw;
    box-sizing: border-box;
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 2vw;
      line-height: 19px;
      i {
        // color: red;
      }
    }
    span {
      color: #006fb8;
      font-size: 12px;
      cursor: pointer;
    }
    .exit {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-bottom: 24px;
    }
    .title {
      h3 {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #006fb8;
        margin-bottom: 1.3vw;
      }
    }
    .form {
      margin: 0 auto;
      width: 83.47vw;
      margin-top: 6.6vw;

      span {
        color: #006fb8;
      }
      .button {
        width: 100%;
        height: 35px;

        background: #006fb8;
        margin-top: 10.67vw;
        margin-bottom: 6.6vw;
      }
    }
  }
  .footer {
    text-align: right;
    margin: 4vw 4vw 0 0;
    img {
      width: 33.6vw;
    }
  }
  .alert {
    width: 100vw;
    // height: 697px;
    // border: 1px solid red;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    background: white;
    box-sizing: border-box;
    padding: 0 26px 26px 26px;
    .mianzeContent {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      text-indent: 2rem;
    }
    h3 {
      font-size: 4.8vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 37px;
      margin-bottom: 26px;
      text-align: center;
      margin-top: 61px;
    }
    h5 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      margin-bottom: 17px;
      text-align: center;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      text-indent: 2rem;
    }
    .wenzhang1 {
      margin-bottom: 26px;
    }
    .el-icon-close {
      float: right;
      position: absolute;
      top: 7.5vw;
      right: 7.5vw;
    }
  }
}
</style>
<style scoped>
.form >>> .el-input__inner {
  height: 35px;
}
.form >>> .el-checkbox__label {
  font-size: 12px;
}
</style>
